export const savingStatusOptions = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'Ready', value: 'READY' },
  { label: 'Disqualified', value: 'DISQUALIFI' },
  { label: 'Processing', value: 'PROCESSING' },
  { label: 'Paid', value: 'PAID' }
];
